$(function ($) {


  $('.product_template_slider').slick({
    dots: true,
    infinite: true,
    arrows:true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  /*---------------- Responsive Menu ------------------*/
  $(".nav-trigger").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".menu-bar").toggleClass("off-canvas");
    e.preventDefault();
  });
  $('.menu-bar').on("click", ".has-submenu a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
    e.stopPropagation();
    e.preventDefault();
  });
  /*---------------- Responsive Menu ------------------*/

  $('.magnific-youtube').magnificPopup({
    disableOn: 200,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });


  /*---------------- EQUAL HEIGHT START ------------------*/
  $(window).on('load',function() {
    equalheight('.announce-sin-item-wrap .display-table');
    equalheight('.celebrity_List');
    equalheight('.border-top');
    equalheight('.pr_border');
    equalheight('.press-box-container');

  });

  $(window).on('resize',function() {
    equalheight('.announce-sin-item-wrap .display-table');
    equalheight('.celebrity_List');
    equalheight('.border-top');
    equalheight('.pr_border');
    equalheight('.press-box-container');

  });
  /*---------------- EQUAL HEIGHT END ------------------*/


  /*---------------- EQUAL HEIGHT START ------------------*/
  //   $(window).on('load',function() {
  //     equalheight('.announce-sin-item-wrap .display-table');
  //     equalheight('.celebrity_List');
  //     equalheight('.border-top');
  //     equalheight('.press-box');

  //   });

  //   $(window).on('resize',function() {
  //     equalheight('.announce-sin-item-wrap .display-table');
  //     equalheight('.celebrity_List');
  //     equalheight('.border-top');
  //     equalheight('.press-box');

  //   });
  /*---------------- EQUAL HEIGHT END ------------------*/

  /*---------------- Toggle Search ------------------*/
  $(".search-toggle").on('click', function (e) {
    $(".header-wrap").toggleClass('search-active');
    e.preventDefault();
  });
  /*---------------- Toggle Search ------------------*/



  /* Shop slider */ 
  $('.shop-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.shop-slider-nav'
  });
  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.shop-slider',
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    vertical:true,
    verticalSwiping:true,
    responsive: [

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },     
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:true
          // horizontal:true,


        }
      },
      { 
        breakpoint:769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
        }
      },
      { 
        breakpoint: 749,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false
        }
      }

    ]
  });

  /*----- qty Start --------*/ 


  $('.qty-btn.plus').click(function (e) {

    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });
  // This button will decrement the value till 0
  $(".qty-btn.minus").click(function (e) {

    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    var fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name=' + fieldName + ']').val(1);
    }
  });

  $("button").on("click", function (ev) {
    var currentQty = $('input[name="quantity"]').val();
    var qtyDirection = $(this).data("direction");
    var newQty = 0;

    if (qtyDirection == "1") {
      newQty = parseInt(currentQty) + 1;
    } else if (qtyDirection == "-1") {
      newQty = parseInt(currentQty) - 1;
    }

    // make decrement disabled at 1
    if (newQty == 1) {
      $(".decrement-quantity").attr("disabled", "disabled");
    }

    // remove disabled attribute on subtract
    if (newQty > 1) {
      $(".decrement-quantity").removeAttr("disabled");
    }

    if (newQty > 0) {
      newQty = newQty.toString();
      $('input[name="quantity"]').val(newQty);
    } else {
      $('input[name="quantity"]').val("1");
    }
  });

  /********************************************************************/

  $('body').on('change', '.prdpgOpt', function(e) {
    if($(this).attr('id') == 'buy2') {
      $(".main-prd-data-var").val($('#threebox').val());
      $(this).closest('.order-rgt').find('.order-price').html($('#threebox').data('price'));
    }
    else {
      $(".main-prd-data-var").val($('#normalbox').val());
      $(this).closest('.order-rgt').find('.order-price').html($('#normalbox').data('price'));
    }
  });

  $('body').on('click','.athena-seven-min-lift-wrap',function(e) {
    e.preventDefault();
    if($('#threebox').val() == $(".main-prd-data-var").val()) {
      $('#AddToCartForm2').submit();
    }
    else {
      $(this).closest('form').submit();
    }
  });

  $('body').on('change', '.chg-subscribe-opt', function(e) {
    $(".bold-ro__subscribe-radio-btn").click();
    if($(this).attr('id') == 'one-time') {
      $('.on-fly-get-optns').hide();
      $(".bold-ro__one-time-radio-btn").click();
      
      if($('#threebox').val() == $(".main-prd-data-var").val()) {
        $(this).closest('.order-rgt').find('.order-price').html($('#threebox').data('price'));
      }
      else {
        $(this).closest('.order-rgt').find('.order-price').html($('#normalbox').data('price'));
      }
    }
    else {
      if($('#threebox').val() == $(".main-prd-data-var").val()) {
        $(this).closest('.order-rgt').find('.order-price').html($('#AddToCartForm2').find('.bold-ro__discounted-price').val());
      }
      else {
        $(this).closest('.order-rgt').find('.order-price').html($(this).closest('form').find('.bold-ro__discounted-price').val());
      }
      $('.on-fly-get-optns').show();
      $(".bold-ro__subscribe-radio-btn").click();
      var get_opt_data = $('.bold-ro__frequency-num').find('option').length;
      var get_opt_html = '';
      if(get_opt_data > 0) {
        var get_freq_nm = '';
        if($('.bold-ro__frequency-type.bold-ro__order-interval').find('option').text().indexOf('Month') !== -1) {
          get_freq_nm = 'months';
        }
        if($('.bold-ro__frequency-type.bold-ro__order-interval').find('option').text().indexOf('Week') !== -1) {
          get_freq_nm = 'weeks';
        }
        if($('.bold-ro__frequency-type.bold-ro__order-interval').find('option').text().indexOf('Year') !== -1) {
          get_freq_nm = 'years';
        }
        get_opt_html += '<select class="customDataSelect">';
        $('.bold-ro__frequency-num option').each(function(a,b) {
          if(a<get_opt_data/2) {
            get_opt_html += '<option value="'+$(this).val()+'">Deliver every '+$(this).val()+' '+get_freq_nm+'</option>';
          }
        });
        get_opt_html += '</select>';
      }
      $('.on-fly-get-optns').html('');
      $('.on-fly-get-optns').html(get_opt_html);
    }
  });

  $('body').on('change', '.customDataSelect', function(e) {
    var get_cur_val = $(this).val();
    $('.bold-ro__frequency-num').val(get_cur_val);
  });

  /********************************************************************/



  $('body').on('click', '.button.minus', function(e) {
    e.preventDefault();
    var get_qty = $(this).closest('.cart-quantity-wrapper').find('input').val();
    if(get_qty >= 1) {
      $(this).closest('.cart-quantity-wrapper').find('input').val(get_qty - 1);
      $(this).closest('.cart-quantity-wrapper').find('input').trigger('change');
    }
  });

  $('body').on('click', '.button.plus', function(e) {
    e.preventDefault();
    var get_qty = $(this).closest('.cart-quantity-wrapper').find('input').val();

    $(this).closest('.cart-quantity-wrapper').find('input').val(parseInt(get_qty) + 1);
    $(this).closest('.cart-quantity-wrapper').find('input').trigger('change');
  });


  $('.rating a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    //     var header = $('#main-header-container');
    //     var sticky = header.outerHeight();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top 
    }, 500, 'linear');

    $('#review-click').trigger('click');
    // $('#spr-summary-actions-newreview').trigger('click');


  });

  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find('.article-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.accordion-container'), false);


  size_li = $(".products-with-tags-section .custom-single-grid-container").size();
  x=8;
  $('.products-with-tags-section .custom-single-grid-container:lt('+x+')').slideDown(1000);
  $('#loadMore').click(function () {
    x= (x+9 <= size_li) ? x+9 : size_li;
    $('.products-with-tags-section .custom-single-grid-container:lt('+x+')').slideDown(500);
  });
  $('#showLess').click(function () {
    x=(x-9<0) ? 8 : x-8;
    $('.products-with-tags-section .custom-single-grid-container').not(':lt('+x+')').slideUp(500);
  });


  /**********************************************************************/
  /*$('body').on('keyup','.main-faq-header .search-faq-query', function (e) {
    e.preventDefault();
    var chck_results = 0;
    var get_search_val = $(this).closest('form').find('.search-faq-query').val().toLowerCase();
    if(get_search_val != '') {
      $('.content-entry .article-title').each(function() {
        if($(this).html().toLowerCase().indexOf(get_search_val) > -1) {
          $(this).closest('.content-entry').show();
          chck_results += 1;
        }
        else if($(this).closest('.content-entry').find('.accordion-content').html().toLowerCase().indexOf(get_search_val) > -1) {
          $(this).closest('.content-entry').show();
          chck_results += 1;
        }
        else {
          $(this).closest('.content-entry').hide();
        }
      });
    }
    else {
      $('.content-entry .article-title').each(function() {
        $(this).closest('.content-entry').show();
      });
    }

    if(chck_results == 0) {
      $('.no-results-wrap').html('No results found matching your query');
    }
    else {
      $('.no-results-wrap').html('');
    }
  });*/
  /**********************************************************************/

  $('body').on('click', '.f-box .f-title', function() {
    $(this).toggleClass('open');
    $(this).closest('.f-box').find('.foot-col-data').slideToggle(600);
  });

  /*---------------- Magnific Video ------------------*/
  $('.product-vimeo-wrap').magnificPopup({
    disableOn: 200,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  /*---------------- Magnific Video ------------------*/


  $('.effeciency-study-link-wrap').magnificPopup({
    delegate: 'a',
    removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function () {
        this.st.mainClass = this.st.el.attr('data-effect');
      }
    },
    midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
  });

  /**********************************************************/
  $('.before-after-slider-hp-wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true
  });
  /**********************************************************/

});

$(document).ready(function() {
  $('.plus-pdp').on('click',function(e){
    var val = parseInt($(this).prev('input').val());
    $(this).prev('input').val( val+1 );
  });
  $('.minus-pdp').on('click',function(e){
    var val = parseInt($(this).next('input').val());
    if(val > 1){
      $(this).next('input').val( val-1 );   
    }
    if(val == 0){
      $(this).next('input').val( 1 );
    }
  });
});
